// ./src/lib/ExitBlocker.js

import Vue from 'vue';

/* global window */

const eventKey = 'beforeunload';

const beforeUnloadHandler = (event) => {
  // eslint-disable-next-line no-param-reassign
  event.returnValue = 'В случае продолжения прогресс может быть утерян';
};

const state = Vue.observable({
  preventExit: false,
});

const getters = {
  preventExit: () => state.preventExit,
};

const mutations = {
  setPrevent() {
    if (state.preventExit) return;
    window.addEventListener(eventKey, beforeUnloadHandler);
  },

  stopPrevent() {
    if (!state.preventExit) return;
    window.removeEventListener(eventKey, beforeUnloadHandler);
  },

  togglePrevent() {
    window[state.preventExit ? 'removeEventListener' : 'addEventListener'](
      eventKey,
      beforeUnloadHandler,
    );
  },
};

export { getters, mutations };
